import { IllustrativeIcon, Surface, Txt } from '@vst/beam';
import { UpArrow } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { CustomStandardModal } from '@app/components/Modal';

import { ModalProps } from '../../types';

import styles from './index.module.scss';

interface PurchaseModalProps extends ModalProps {
  retentionOfferName: string;
}
const SuccessModal = ({ isOpen, retentionOfferName, handleCancel, handleContinue }: PurchaseModalProps) => {
  const { t } = useTranslation('Disconnect');
  return (
    <CustomStandardModal
      isOpen={isOpen}
      onClose={handleCancel}
      size={'medium'}
      header={''}
      actions={{
        primary: {
          label: `${t('retentionOffers.confirmationModalSuccess.primaryButton')}`,
          onClick: handleContinue,
        },
      }}
    >
      <Surface className={styles.modalContentWrapper}>
        <IllustrativeIcon icon={UpArrow} color="teal_600" size="80px" mb="16px" />
        <Txt variant="heading5">
          {t('retentionOffers.confirmationModalSuccess.title', {
            value: retentionOfferName,
          })}
        </Txt>
        <Txt variant="bodySmallRegular" color="subtle">
          {t('retentionOffers.confirmationModalSuccess.description')}
        </Txt>
      </Surface>
    </CustomStandardModal>
  );
};

export default SuccessModal;
